/*
 *
 * Customer constants
 *
 */

export const DEFAULT_ACTION = 'app/Customer/DEFAULT_ACTION';
